<template>
    <div class="map-content">
        <el-form class="data-form">
            <el-form-item>
                <el-autocomplete
                    class="inp"
                    popper-class="my-autocomplete"
                    v-model="state"
                    :fetch-suggestions="searchAddr"
                    placeholder="请输入地址"
                    :trigger-on-focus="false"
                    @select="handleSelect"
                >
                    <i class="el-icon-location-outline el-input__icon" slot="suffix" title="选择地址"></i>
                    <template slot-scope="{ item }">
                        <div class="name">{{ item.name }}</div>
                        <span class="addr" v-if="item.address.length > 0">{{ item.district }}{{ item.address }}</span>
                        <span class="addr" v-else>{{ item.district }}</span>
                    </template>
                </el-autocomplete>
                <div class="map-show" id="map-show" style="height: 300px;width: 100%;"></div>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
// import AMap from 'AMap';
export default {
    name: 'WorkTimeMap',
    props: {
        longitude: {
            type: Number
        },
        latitude: {
            type: Number
        },
        isNewData: {
            type: Number
        }
    },
    data () {
        return {
            mapsData: {
                longitude: '',
                latitude: '',
                clockArea: '',
                nearestPOI: '',
                nearestJunction: '',
                nearestRoad: '',
                address: ''

            },
            searchContent: '',
            restaurants: [],
            state: ''
        };
    },
    created () {
        // if (this.isNewData === 0) {
        //     let center = [this.longitude, this.latitude];
        //     this.initShowMap(center);
        // } else {
        //     this.geCurrentPosi();
        // }
    },
    methods: {
        searchAddr (queryString, cb) {
            var _this = this;
            // AMap.plugin('AMap.Autocomplete', () => {
            //     let autoOptions = {
            //         city: '全国'
            //     };
            //     let autoComplete = new AMap.Autocomplete(autoOptions); // 初始化autocomplete
            //     autoComplete.search(queryString, (status, result) => {
            //         if (result.info === 'OK') {
            //             _this.restaurants = result.tips;
            //             cb(_this.restaurants);
            //         }
            //     });
            // });
        },
        initShowMap (center) {
            // AMapUI.loadUI(['misc/PositionPicker'], PositionPicker => {
            //     this.snameMap = new AMap.Map('map-show', {
            //         zoom: 17,
            //         scrollWheel: false,
            //         center: center
            //     });
            //     let positionPicker = new PositionPicker({
            //         mode: 'dragMap',
            //         map: this.snameMap
            //     });
            //     positionPicker.on('success', positionResult => {
            //         this.mapsData.longitude = positionResult.position.lng;
            //         this.mapsData.latitude = positionResult.position.lat;
            //         this.mapsData.nearestPOI = positionResult.nearestPOI;
            //         this.mapsData.nearestJunction = positionResult.nearestJunction;
            //         this.mapsData.nearestRoad = positionResult.nearestRoad;
            //         this.mapsData.address = positionResult.address;
            //         this.$emit('getMapsData', this.mapsData);
            //     });
            //     positionPicker.on('fail', positionResult => {
            //         this.$message.error('地址选取失败');
            //     });
            //     positionPicker.start();
            // });
        },
        handleSelect (item) {
            if (item.id === '') {
                this.$message.error('请选择详细地址');
            } else {
                this.state = item.name;
                this.mapsData.longitude = item.location.lng;
                this.mapsData.latitude = item.location.lat;
                this.$emit('getMapsData', this.mapsData);
                let center = [item.location.lng, item.location.lat];
                this.initShowMap(center);
            }
        },
        geCurrentPosi () {
            // var _this = this;
            // var map = new AMap.Map('container', {
            //     resizeEnable: true
            // });
            // AMap.plugin('AMap.Geolocation', function () {
            //     var geolocation = new AMap.Geolocation({
            //         enableHighAccuracy: true, // 是否使用高精度定位，默认:true
            //         timeout: 5000 // 超过10秒后停止定位，默认：5s
            //     });
            //     map.addControl(geolocation);
            //     geolocation.getCurrentPosition(function (status, result) {
            //         if (status === 'complete') {
            //             let center = [result.position.lng, result.position.lat];
            //             _this.initShowMap(center);
            //         } else {
            //             // console.log(result);
            //             // 定位失败默认当前位置为首都
            //             let center = [116.405285, 39.904989];
            //             _this.initShowMap(center);
            //         }
            //     });
            // });
        }
    }
};
</script>

<style lang="less">
.amap-copyright,
.amap-logo {
    display: none !important;
}
.inp {
    width: 100%;
}
.my-autocomplete {
    li {
        line-height: normal;
        padding: 7px;

        .name {
            text-overflow: ellipsis;
            overflow: hidden;
        }
        .addr {
            font-size: 12px;
            color: #b4b4b4;
        }

        .highlighted .addr {
            color: #ddd;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/office/workTime/WorkTimeDetail/WorkTimeMap.vue